import { render, staticRenderFns } from "./props.vue?vue&type=template&id=97c55590&scoped=true"
import script from "./props.vue?vue&type=script&lang=js"
export * from "./props.vue?vue&type=script&lang=js"
import style0 from "./props.vue?vue&type=style&index=0&id=97c55590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c55590",
  null
  
)

export default component.exports